// schema
import * as ISchema from "@schema";

// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";

// web-app-onboarding-complete imports
import { IRendererProps } from "./WebAppOnboardingComplete.d";
import { WebAppOnboardingComplete } from "./WebAppOnboardingComplete";
import { webAppOnboardingCompleteQuery } from "./WebAppOnboardingComplete.gql";

// components
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";

// util
import { handleReadyStateError } from "@util/relay.util";

///////////////
// Component //
///////////////
export class WebAppOnboardingCompleteRenderer extends React.PureComponent<IRendererProps, {}> {
  public render() {
    const { environment, orgRelayId } = this.props;

    return (
      <QueryRenderer
        environment={environment}
        query={webAppOnboardingCompleteQuery}
        variables={{ orgRelayId }}
        cacheConfig={{ force: true }}
        render={(readyState: ReadyState) => {
          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "WebAppOnboardingCompleteRenderer");

            return null;
          }

          const org = readyState && readyState.props && (readyState.props.org as ISchema.IOrg);

          if (!org) {
            return <CircularProgress />;
          }

          return <WebAppOnboardingComplete org={org} />;
        }}
      />
    );
  }
}
